import React, { useEffect } from 'react';
import { Modal } from 'bootstrap';

const SuccessModal = () => {
  useEffect(() => {
    const successModal = document.getElementById('successModal');
    const bsSuccessModal = Modal.getInstance(successModal) || new Modal(successModal);

    // Handle modal close event
    successModal.addEventListener('hidden.bs.modal', () => {
      // Remove modal backdrop
      const backdrop = document.querySelector('.modal-backdrop');
      if (backdrop) {
        backdrop.remove();
      }
      // Remove modal-open class from body
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    });

    return () => {
      // Cleanup event listener
      successModal.removeEventListener('hidden.bs.modal', () => {});
    };
  }, []);

  return (
    <div className="modal fade" id="successModal" tabIndex="-1" aria-labelledby="successModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content" style={{ borderRadius: '15px', border: 'none' }}>
          <div className="modal-header" 
               style={{ 
                 background: 'linear-gradient(to right, #5de0e6, #004aad)', 
                 borderRadius: '15px 15px 0 0', 
                 border: 'none' 
               }}>
            <h5 className="modal-title text-white" id="successModalLabel">Thành công</h5>
            <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body text-center" style={{ padding: '2rem' }}>
            <h4>Đơn hàng của bạn đã được gửi thành công!</h4>
            <p>Chúng tôi sẽ liên hệ với bạn trong thời gian sớm nhất.</p>
          </div>
          <div className="modal-footer" style={{ borderTop: 'none', padding: '1rem 2rem 2rem' }}>
            <button type="button" 
                    className="btn btn-secondary" 
                    data-bs-dismiss="modal" 
                    style={{ borderRadius: '25px', padding: '8px 20px' }}>
              Đóng
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal; 